export class ChangeFilterAction {
  static readonly type = '[Table] Change filter';

  constructor(readonly filters: { tableId: string; value: unknown }) {}
}
